// Central site constants used by every SEO surface — titles, canonicals,
// JSON-LD schema, sitemap, hreflang. Keep NAP (name/address/phone) here
// so it stays consistent across pages, footer schema and LocalBusiness.

export const SITE_URL = "https://www.euro-steel.co.nz";
export const SITE_NAME = "EUROSTEEL";
export const SITE_TITLE_DEFAULT =
  "EUROSTEEL — Steel Windows, Doors & Aluminium Systems | New Zealand";
export const SITE_DESCRIPTION_DEFAULT =
  "Slim-profile steel windows and doors, thermally-broken and H1-compliant for New Zealand. FerroFinestra sight-lines, custom joinery, Auckland showroom.";
export const SITE_LOCALE = "en_NZ";
export const SITE_COUNTRY = "NZ";

// Primary Open Graph / Twitter image — hero-scale, 1600×900 works best.
export const OG_IMAGE_DEFAULT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_2ed0240b-8186-438f-82ff-c30b1e517b68/artifacts/mmjyvrt7_W40.jpg";

export const BRAND = {
  legalName: "Eurosteel New Zealand",
  displayName: "EUROSTEEL",
  logo:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_5f9461bb-28a7-4bac-8192-aecb42807f6c/artifacts/o2i65m5i_ChatGPT%20Image%20Jul%2021%2C%202026%2C%2005_14_37%20PM.png",
  founded: "2019",
};

export const CONTACT = {
  phone: "+64279152526",
  phoneDisplay: "+64 27 915 2526",
  emailPrimary: "isaiah@euro-steel.co.nz",
  emailOrders: "orders@euro-steel.co.nz",
};

export const SHOWROOM = {
  street: "3 Byron Avenue",
  suburb: "Takapuna",
  city: "Auckland",
  region: "Auckland",
  postalCode: "0622",
  country: "New Zealand",
  countryCode: "NZ",
  // Approximate showroom coordinates — refine when supplied.
  latitude: -36.7864,
  longitude: 174.7708,
  hours: [
    { days: "Monday - Friday", opens: "08:30", closes: "17:00" },
    { days: "Monday - Saturday (showroom)", opens: "By appointment", closes: "" },
  ],
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/eurosteelnz",
  facebook: "https://www.facebook.com/eurosteelnz",
  linkedin: "https://www.linkedin.com/company/eurosteel-nz",
};

// Absolute URL helper used by canonicals, sitemap and og:url.
export const absUrl = (path = "/") =>
  `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
